import React from 'react';
import { Drawer, Tooltip } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export default function CustomDrawer({
  open,
  handelClose,
  reservations,
  messages
}) {
  return (
    <Drawer open={open} onClose={handelClose}>
      <div className='w-[500px] p-5'>
        <div className='flex justify-between items-center '>
          <p className='font-inter text-xl font-semiBold'>Notifications</p>
          <div
            className='w-8 h-8 rounded-full bg-primary hover:bg-primaryDark cursor-pointer flex justify-center items-center'
            onClick={handelClose}
          >
            <CloseIcon sx={{color: 'white'}} fontSize='small'/>
          </div>
            
        </div>
        {reservations.length + messages.length === 0 && (
          <p className='text-xl text-primary font-inter border-dashed border-2 rounded-[20px] p-5 mt-5'>Aucune notification</p>
        )}
        {reservations.map((item, index) => {
          return (
            <div key={index} className='rounded-[20px] bg-primary mt-5 flex justify-between items-center px-5 py-2'>
              <p className='text-xl text-white w-[250px]'>Demande de réservation de salle en cours de traitement</p>
              <Tooltip title={item.formateur}>
                <div className='bg-white rounded-full w-32 flex justify-center items-center h-8 cursor-pointer'>
                  <p className='text-primary text-xl overflow-ellipsis whitespace-nowrap overflow-hidden px-5'>{item.formateur}</p>
                </div>
              </Tooltip>
            </div>
          );
        })}
        {messages.map((item) => {
          return (
            <div className='rounded-[20px] bg-white border-2 border-primary mt-5 flex justify-between items-center px-5 py-2'>
              <p className='text-xl text-primary w-[250px]'>Un message pas encors traité</p>
              <Tooltip title={item.nom}>
                <div className='bg-primary rounded-full w-32 flex justify-center items-center h-8 cursor-pointer'>
                  <p className='text-white text-xl overflow-ellipsis whitespace-nowrap overflow-hidden px-5'>{item.nom}</p>
                </div>
              </Tooltip>
            </div>
          );
        })}
      </div>
    </Drawer>
  );
} 